import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

const [useRegenerateJoinLink, regenerateJoinLink] = createAsyncAction(
  "spaces/regenerateJoinLink",
  async (spaceId: number) => {
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}/join-link`,
      method: "PUT",
    });
    return { ...res, result: res.result.space };
  }
);

export default useRegenerateJoinLink;
export { regenerateJoinLink };
